/* Judge.me — label the Swedish product-review widget accurately. */
(() => {
  if (document.documentElement.lang !== 'sv') return;

  const selector = '#judgeme_product_reviews .jm-review-widget-minimal-header__title';
  const label = 'Produktrecensioner';

  const updateTitle = () => {
    const title = document.querySelector(selector);
    if (!title) return false;

    if (title.textContent.trim() !== label) title.textContent = label;
    return true;
  };

  const start = () => {
    if (updateTitle()) return;

    const observer = new MutationObserver(() => {
      if (updateTitle()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
